module.exports = __webpack_public_path__ + "static/media/viewCertificate.b26750bf.svg";